export const formatTimeStamp = (value, spe = '-', type = 0) => {
	value = value * 1000
	let data = new Date(value)
	let year = data.getFullYear()
	let month = data.getMonth() + 1
	let day = data.getDate()
	// let h = data.getHours()
	// let mm = data.getMinutes()
	// let s = data.getSeconds()
	month = month >= 10 ? month : '0' + month
	day = day >= 10 ? day : '0' + day
	// h = h >= 10 ? h : '0' + h
	// mm = mm >= 10 ? mm : '0' + mm
	// s = s >= 10 ? s : '0' + s
	if (type == 0) {
		return `${year}${spe}${month}${spe}${day} `
	} else {
		return `${year}${spe}${month}${spe}${day} `
	}
}
